export default "__VITE_ASSET__RwOws1hC__"